import { Identifiable } from './identifiable';

export class Auditable extends Identifiable {
  created: Date;
  createdBy: string;
  modified: Date;
  modifiedBy: string;
  deleted: Date;
}
